// extracted by mini-css-extract-plugin
export default {"pageWrap":"sc-z","fullWidth":"tc-z","heading":"uc-z","fullBleed":"vc-z","hidden":"wc-z"};